import { useEffect, useMemo } from 'react';
import { UseRecurlyInstance } from '@recurly/react-recurly';
import { datadogLogs } from '@datadog/browser-logs';
import { PayPalInstance } from 'recurly.js';
import { getEnv } from '../utils/environment';

const PAYPAL_ERROR = 'Paypal error: ';
const PAYPAL_SUCCESS = 'Paypal payment success';
const PAYPAL_FLOW_CANCELED = 'PayPal flow canceled';
export const DISPLAY_NAME = 'FabFitFun';

interface PayPalProps {
  recurly: UseRecurlyInstance;
  onPaypalVerify: (token: string) => void;
  onPaypalError: (error: string) => void;
  onPaypalCancel: () => void;
}

const usePayPal = ({ recurly, onPaypalVerify, onPaypalError, onPaypalCancel }: PayPalProps) => {
  const payPal = useMemo<PayPalInstance>(() => {
    const paypalInstance = recurly.PayPal({
      display: { displayName: DISPLAY_NAME },
      braintree: { clientAuthorization: getEnv().brainTreePublicKey },
    });
    window.payPal = paypalInstance;
    return paypalInstance;
  }, []);

  useEffect(() => {
    if (payPal) {
      payPal.on('token', (token: any, err: any) => {
        datadogLogs.logger.info(PAYPAL_SUCCESS);
        onPaypalVerify(token.id);
      });

      payPal.on('error', (err) => {
        datadogLogs.logger.error(PAYPAL_ERROR, {}, err);
        onPaypalError(err.message);
      });

      payPal.on('cancel', () => {
        datadogLogs.logger.info(PAYPAL_FLOW_CANCELED);
        onPaypalCancel();
      });
    }
  }, [payPal]);
};

export default usePayPal;
